import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { MasteryListItemSkeleton } from "../MasteryListItem/MasteryListItemSkeleton";
import { Skeleton } from "../Skeleton";

const SUBHEADER_LINE_HEIGHT = 20;
const SUBHEADER_PADDING_VERTICAL = 18;
const CHIP_HEIGHT = 32;

export type TagsSectionSkeletonConfig = {
	numRows: number;
	showChip?: boolean;
};

type Props = {
	sections?: TagsSectionSkeletonConfig[];
};

const DEFAULT_SECTIONS: TagsSectionSkeletonConfig[] = [{ numRows: 4 }];

const SectionHeaderSkeleton = ({ showChip }: { showChip?: boolean }) => {
	const { isMobile } = useDevice();

	return (
		<Box
			justifyContent="space-between"
			flexDirection="row"
			alignItems="center"
			paddingHorizontal={isMobile ? 16 : 0}
		>
			<Box
				height={SUBHEADER_LINE_HEIGHT + SUBHEADER_PADDING_VERTICAL * 2}
				justifyContent="center"
			>
				<Skeleton width={164} height={14} />
			</Box>
			{showChip && <Skeleton width={84} height={CHIP_HEIGHT} />}
		</Box>
	);
};

export const TagsSectionListSkeleton = ({
	sections = DEFAULT_SECTIONS,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box gap={16} paddingTop={isMobile ? 8 : 16} paddingBottom={24}>
			{sections.map(({ numRows, showChip }, sectionIndex) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton sections
				<Box gap={8} key={sectionIndex}>
					<SectionHeaderSkeleton showChip={showChip} />
					<FlatCard
						style={{ overflow: "hidden", ...(isMobile && { borderRadius: 0 }) }}
					>
						{Array.from({ length: numRows }).map((_, rowIndex) => (
							// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton rows
							<MasteryListItemSkeleton key={rowIndex} />
						))}
					</FlatCard>
				</Box>
			))}
		</Box>
	);
};
